import { AccountModel } from "cakemail-ui-components-v2"

export type TTemplateSharingStoredFilters = {
    [k: string]: TTemplateSharingFilters
}

export type TTemplateSharingFilters = {
    search?: string,
    orderBy?: string,
    order?: "asc" | "desc",
    tab?: string
}

export enum ETemplateSharingTabs {
    all = "all",
    shared = "shared"
}